import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/js/bootstrap.min.js';

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light">
    <div className="container">
      <button
        className="navbar-toggler text-white bg-light"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon bg-white rounded-2"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav ml-auto">
          <li className="btni nav-item ms-5 ">
            <Link to="/" className="nav-link text-light">Home</Link>
          </li>
          <li className="btni nav-item ms-5">
            <Link to="/projects" className="nav-link text-light">Projects</Link>
          </li>
          <li className="btni nav-item ms-5">
            <Link to="/ContactMe" className="nav-link text-light">Contact Me</Link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  
  );
}

export default Navbar;

